import React, { Component } from 'react';
import Main from '../Main/Main';
import Work from '../Work/Work';
import Team from '../Team/Team';
import Footer from '../Footer/Footer';
import Tech from '../Tech/Tech';
import Menu from '../Menu/Menu';
import Project from '../Project/Project';

import './App.css';
import ContactForm from '../ContactForm/ContactForm';

class App extends Component {
  constructor () {
    super ()

    this.state = {
      projectVisible: false,
      active: ''
    }
  }

  displayProject = (activeProject) => {
    this.setState({projectVisible:!this.state.projectVisible,
      active: activeProject
    })
  }

  hideProject = () => {
    this.setState({projectVisible: false
    })
  }

  componentDidMount() {
    const myNav = document.querySelector('.menu-container')
    window.onscroll = () => {
      if (document.body.scrollTop >= 180 || document.documentElement.scrollTop >= 180) {
        myNav.classList.add("after");
      } else {
        myNav.classList.remove("after");
      }
    };
  }

  render() {

    if(this.state.projectVisible === true){
      return(
        <div className="App"id='app'>
          <Menu hideProject={this.hideProject}/>
          <div onLoad={() => this.refs.item.focus()}>
            <Project displayProject={this.displayProject}
                      activeProject={this.state.active}
            />
          </div>
        </div>
      )
    }

      return (
        <div className="App"id='app'>
          <Menu hideProject={this.hideProject}/>
          <Main />
          <Work displayProject={this.displayProject}/>
          <Tech />
          <Team />
          <ContactForm />
          <Footer />
          <div className='menu-bottom'>
            <div className="copy">
              <p>© 2018 Werkap, Tech Heroes.</p>
            </div>
            <div className='menu2'>
            <h1 className='subscribe'>Subscribe to our newsletter:</h1>
              <div className='input-box'>
                <input placeholder='Enter Your Email Address'/>
                <button>Submit</button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js